import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth
export const login = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, { email, password });
  return response.data;
};

export const verifyOTP = async (email, otp) => {
  const response = await axios.post(`${API}/auth/verify-otp`, { email, otp });
  return response.data;
};

export const resendOTP = async (email) => {
  const response = await axios.post(`${API}/auth/resend-otp?email=${encodeURIComponent(email)}`);
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await axios.post(`${API}/auth/change-password`, {
    current_password: currentPassword,
    new_password: newPassword
  });
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post(`${API}/auth/request-password-reset?email=${encodeURIComponent(email)}`);
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await axios.post(`${API}/auth/reset-password`, {
    token,
    new_password: newPassword
  });
  return response.data;
};

export const verifyEmail = async (token) => {
  const response = await axios.get(`${API}/auth/verify-email?token=${token}`);
  return response.data;
};

export const resendVerification = async (email) => {
  const response = await axios.post(`${API}/auth/resend-verification?email=${encodeURIComponent(email)}`);
  return response.data;
};

export const toggleMFA = async (enable) => {
  const response = await axios.post(`${API}/auth/toggle-mfa?enable=${enable}`);
  return response.data;
};

export const getMyProfile = async () => {
  const response = await axios.get(`${API}/auth/me`);
  return response.data;
};

// Conversations
export const getConversations = async (channel = 'all', channelId = null, limit = 50, skip = 0) => {
  const params = { limit, skip };
  if (channel !== 'all') {
    params.channel = channel;
  }
  if (channelId) {
    params.channel_id = channelId;
  }
  const response = await axios.get(`${API}/conversations/`, { params });
  return response.data;
};

export const getConversation = async (id) => {
  const response = await axios.get(`${API}/conversations/${id}`);
  return response.data;
};

export const sendMessage = async (conversationId, text, attachments = [], senderNumber = null) => {
  const payload = { text, attachments };
  if (senderNumber) {
    payload.sender_number = senderNumber;
  }
  const response = await axios.post(`${API}/conversations/${conversationId}/messages`, payload);
  return response.data;
};

export const uploadAttachment = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API}/attachments/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getAttachmentUrl = (filename) => `${API}/attachments/download/${filename}`;

export const assignConversation = async (conversationId, agentId) => {
  const response = await axios.put(`${API}/conversations/${conversationId}/assign?agent_id=${agentId}`);
  return response.data;
};

export const updateConversationStatus = async (conversationId, status) => {
  const response = await axios.put(`${API}/conversations/${conversationId}/status?status=${status}`);
  return response.data;
};

export const updateCustomerInfo = async (conversationId, data) => {
  const response = await axios.put(`${API}/conversations/${conversationId}/customer`, data);
  return response.data;
};

// Users/Agents
export const getUsers = async () => {
  const response = await axios.get(`${API}/users/`);
  return response.data;
};

export const getAgents = async () => {
  const response = await axios.get(`${API}/users/agents`);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await axios.post(`${API}/users/`, userData);
  return response.data;
};

export const updateUser = async (userId, updates) => {
  const response = await axios.put(`${API}/users/${userId}`, updates);
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await axios.delete(`${API}/users/${userId}`);
  return response.data;
};

export const updateUserStatus = async (userId, status) => {
  const response = await axios.put(`${API}/users/${userId}/status?status=${status}`);
  return response.data;
};

// Channels
export const getChannelsSummary = async () => {
  const response = await axios.get(`${API}/channels/summary`);
  return response.data;
};

// WhatsApp
export const getWhatsAppChannels = async () => {
  const response = await axios.get(`${API}/channels/whatsapp`);
  return response.data;
};

export const getWhatsAppSenders = async () => {
  const response = await axios.get(`${API}/channels/whatsapp`);
  return response.data;
};

export const createWhatsAppChannel = async (data) => {
  const response = await axios.post(`${API}/channels/whatsapp`, data);
  return response.data;
};

export const updateWhatsAppChannel = async (id, data) => {
  const response = await axios.put(`${API}/channels/whatsapp/${id}`, data);
  return response.data;
};

export const deleteWhatsAppChannel = async (id) => {
  const response = await axios.delete(`${API}/channels/whatsapp/${id}`);
  return response.data;
};

export const testWhatsAppChannel = async (id) => {
  const response = await axios.post(`${API}/channels/whatsapp/${id}/test`);
  return response.data;
};

// Facebook
export const getFacebookChannels = async () => {
  const response = await axios.get(`${API}/channels/facebook`);
  return response.data;
};

export const createFacebookChannel = async (data) => {
  const response = await axios.post(`${API}/channels/facebook`, data);
  return response.data;
};

export const updateFacebookChannel = async (id, data) => {
  const response = await axios.put(`${API}/channels/facebook/${id}`, data);
  return response.data;
};

export const deleteFacebookChannel = async (id) => {
  const response = await axios.delete(`${API}/channels/facebook/${id}`);
  return response.data;
};

export const testFacebookChannel = async (id) => {
  const response = await axios.post(`${API}/channels/facebook/${id}/test`);
  return response.data;
};

// Email
export const getEmailChannels = async () => {
  const response = await axios.get(`${API}/channels/email`);
  return response.data;
};

export const createEmailChannel = async (data) => {
  const response = await axios.post(`${API}/channels/email`, data);
  return response.data;
};

export const updateEmailChannel = async (id, data) => {
  const response = await axios.put(`${API}/channels/email/${id}`, data);
  return response.data;
};

export const deleteEmailChannel = async (id) => {
  const response = await axios.delete(`${API}/channels/email/${id}`);
  return response.data;
};

export const testEmailChannel = async (id) => {
  const response = await axios.post(`${API}/channels/email/${id}/test`);
  return response.data;
};

// Legacy Automation (simple auto-responses)
export const getAutoResponses = async () => {
  const response = await axios.get(`${API}/automation/`);
  return response.data;
};

export const createAutoResponse = async (data) => {
  const response = await axios.post(`${API}/automation/`, data);
  return response.data;
};

export const updateAutoResponse = async (id, data) => {
  const response = await axios.put(`${API}/automation/${id}`, data);
  return response.data;
};

export const deleteAutoResponse = async (id) => {
  const response = await axios.delete(`${API}/automation/${id}`);
  return response.data;
};

export const toggleAutoResponse = async (id) => {
  const response = await axios.put(`${API}/automation/${id}/toggle`);
  return response.data;
};

// NEW: Advanced Automations
export const getAutomations = async () => {
  const response = await axios.get(`${API}/automations/`);
  return response.data;
};

export const getAutomation = async (id) => {
  const response = await axios.get(`${API}/automations/${id}`);
  return response.data;
};

export const createAutomation = async (data) => {
  const response = await axios.post(`${API}/automations/`, data);
  return response.data;
};

export const updateAutomation = async (id, data) => {
  const response = await axios.put(`${API}/automations/${id}`, data);
  return response.data;
};

export const deleteAutomation = async (id) => {
  const response = await axios.delete(`${API}/automations/${id}`);
  return response.data;
};

export const toggleAutomation = async (id) => {
  const response = await axios.put(`${API}/automations/${id}/toggle`);
  return response.data;
};

export const getAutomationTemplates = async () => {
  const response = await axios.get(`${API}/automations/templates`);
  return response.data;
};

export const processAutomation = async (conversationId, messageText) => {
  const response = await axios.post(`${API}/automations/process?conversation_id=${conversationId}&message_text=${encodeURIComponent(messageText)}`);
  return response.data;
};

// Chat Flows (legacy - keeping for compatibility)
export const getChatFlows = async () => {
  const response = await axios.get(`${API}/flows/`);
  return response.data;
};

export const createChatFlow = async (data) => {
  const response = await axios.post(`${API}/flows/`, data);
  return response.data;
};

export const updateChatFlow = async (id, data) => {
  const response = await axios.put(`${API}/flows/${id}`, data);
  return response.data;
};

export const deleteChatFlow = async (id) => {
  const response = await axios.delete(`${API}/flows/${id}`);
  return response.data;
};

export const toggleChatFlow = async (id) => {
  const response = await axios.put(`${API}/flows/${id}/toggle`);
  return response.data;
};

// Analytics
export const getAnalytics = async (startDate = null, endDate = null) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await axios.get(`${API}/analytics/`, { params });
  return response.data;
};

export const getAgentActivity = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await axios.get(`${API}/analytics/agent-activity`, { params });
  return response.data;
};

export const getAgentProductivity = async (agentId, startDate, endDate) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const response = await axios.get(`${API}/analytics/agent-productivity/${agentId}`, { params });
  return response.data;
};

// Settings
export const getSettings = async () => {
  const response = await axios.get(`${API}/settings/`);
  return response.data;
};

export const getSatisfactionSettings = async () => {
  const response = await axios.get(`${API}/settings/satisfaction-survey`);
  return response.data;
};

export const updateSatisfactionSettings = async (data) => {
  const response = await axios.put(`${API}/settings/satisfaction-survey`, data);
  return response.data;
};

export const updateGeneralSettings = async (data) => {
  const response = await axios.put(`${API}/settings/general`, data);
  return response.data;
};

export const updateNotificationSettings = async (data) => {
  const response = await axios.put(`${API}/settings/notifications`, data);
  return response.data;
};

export const updateSecuritySettings = async (data) => {
  const response = await axios.put(`${API}/settings/security`, data);
  return response.data;
};

export const updateBusinessHoursSettings = async (data) => {
  const response = await axios.put(`${API}/settings/business-hours`, data);
  return response.data;
};

// Claims
export const getClaims = async (filters = {}) => {
  const response = await axios.get(`${API}/claims/`, { params: filters });
  return response.data;
};

export const getClaimsStats = async () => {
  const response = await axios.get(`${API}/claims/stats`);
  return response.data;
};

export const getClaim = async (claimId) => {
  const response = await axios.get(`${API}/claims/${claimId}`);
  return response.data;
};

export const createClaim = async (data) => {
  const response = await axios.post(`${API}/claims/`, data);
  return response.data;
};

export const updateClaim = async (claimId, data) => {
  const response = await axios.put(`${API}/claims/${claimId}`, data);
  return response.data;
};

export const deleteClaim = async (claimId) => {
  const response = await axios.delete(`${API}/claims/${claimId}`);
  return response.data;
};

export const addClaimFollowUp = async (claimId, text) => {
  const response = await axios.post(`${API}/claims/${claimId}/follow-up`, { text });
  return response.data;
};

export const forwardClaim = async (claimId, recipientEmail, note = '') => {
  const response = await axios.post(`${API}/claims/${claimId}/forward`, { 
    recipient_email: recipientEmail,
    note: note
  });
  return response.data;
};

// Archive APIs
export const getArchivedConversations = async (channel = null, limit = 50, skip = 0) => {
  const params = { limit, skip };
  if (channel) params.channel = channel;
  const response = await axios.get(`${API}/conversations/archive/list`, { params });
  return response.data;
};

export const getArchiveStats = async () => {
  const response = await axios.get(`${API}/conversations/archive/stats`);
  return response.data;
};

export const restoreArchivedConversation = async (conversationId) => {
  const response = await axios.post(`${API}/conversations/archive/${conversationId}/restore`);
  return response.data;
};

// Customer APIs
export const getCustomers = async (search = null, limit = 50, skip = 0) => {
  const params = { limit, skip };
  if (search) params.search = search;
  const response = await axios.get(`${API}/customers/`, { params });
  return response.data;
};

export const lookupCustomer = async (phone = null, email = null, messengerId = null) => {
  const params = {};
  if (phone) params.phone = phone;
  if (email) params.email = email;
  if (messengerId) params.messenger_id = messengerId;
  const response = await axios.get(`${API}/customers/lookup`, { params });
  return response.data;
};

export const getCustomer = async (customerId) => {
  const response = await axios.get(`${API}/customers/${customerId}`);
  return response.data;
};

export const createCustomer = async (customerData) => {
  const response = await axios.post(`${API}/customers/`, customerData);
  return response.data;
};

export const updateCustomer = async (customerId, customerData) => {
  const response = await axios.put(`${API}/customers/${customerId}`, customerData);
  return response.data;
};

export const deleteCustomer = async (customerId) => {
  const response = await axios.delete(`${API}/customers/${customerId}`);
  return response.data;
};

export const getCustomerConversations = async (customerId, limit = 20) => {
  const response = await axios.get(`${API}/customers/${customerId}/conversations`, { params: { limit } });
  return response.data;
};

// Satisfaction Trends
export const getSatisfactionTrends = async (period = '30d') => {
  const response = await axios.get(`${API}/analytics/satisfaction-trends`, { params: { period } });
  return response.data;
};

// Twilio Config
export const getTwilioConfig = async () => {
  const response = await axios.get(`${API}/twilio/config`);
  return response.data;
};

export const saveTwilioConfig = async (data) => {
  const response = await axios.post(`${API}/twilio/config`, data);
  return response.data;
};

export const testTwilioConfig = async () => {
  const response = await axios.post(`${API}/twilio/config/test`);
  return response.data;
};

export const getTwilioWebhookUrl = async () => {
  const response = await axios.get(`${API}/twilio/webhook-url`);
  return response.data;
};

// Routing Rules
export const getRoutingRules = async () => {
  const response = await axios.get(`${API}/routing/rules`);
  return response.data;
};

export const createRoutingRule = async (data) => {
  const response = await axios.post(`${API}/routing/rules`, data);
  return response.data;
};

export const updateRoutingRule = async (id, data) => {
  const response = await axios.put(`${API}/routing/rules/${id}`, data);
  return response.data;
};

export const deleteRoutingRule = async (id) => {
  const response = await axios.delete(`${API}/routing/rules/${id}`);
  return response.data;
};

export const applyRoutingToUnassigned = async () => {
  const response = await axios.post(`${API}/routing/apply-to-unassigned`);
  return response.data;
};

// Forward & Download
export const forwardConversationEmail = async (conversationId, data) => {
  const response = await axios.post(`${API}/conversations/${conversationId}/forward-email`, data);
  return response.data;
};

export const downloadConversation = async (conversationId) => {
  const response = await axios.get(`${API}/conversations/${conversationId}/download`, {
    responseType: 'blob'
  });
  return response;
};

// Message Templates
export const getTemplates = async () => {
  const response = await axios.get(`${API}/templates/`);
  return response.data;
};

export const createTemplate = async (data) => {
  const response = await axios.post(`${API}/templates/`, data);
  return response.data;
};

export const updateTemplate = async (id, data) => {
  const response = await axios.put(`${API}/templates/${id}`, data);
  return response.data;
};

export const deleteTemplate = async (id) => {
  const response = await axios.delete(`${API}/templates/${id}`);
  return response.data;
};

// Email Sync
export const syncEmails = async () => {
  const response = await axios.post(`${API}/email/sync`);
  return response.data;
};
